<template>
  <div class="newsContainer">
    <div class="home-top">
      <div class="head">
        <div class="companyName">
          <div>
            <a href="/"><img src="../../../public/images/campany.png" alt="" /></a>
          </div>
        </div>
        <div class="phone">
          <!-- <img src="../../assets/shouji.png" alt="">13241800875 -->
          <img class="menuCopy" @click="isSeeList()" src="../../assets/menu.png" alt="" />
        </div>
      </div>
      <!-- 移动端的menu菜单 -->
      <div class="copyMenu" v-if="isSeeMenuList">
        <a href="/"><div class="item">首页</div></a>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <a href="news"> <div class="item">公司资讯</div></a>
        <a href="businessnew"><div class="item">公司业务</div></a>
        <a href="joinUs"><div class="item" style="border-bottom: none">联系我们</div></a>
      </div>
      <div class="menu" v-if="!isSeeMenuList">
        <a href="/"><div class="item">首页</div></a>
        <div class="border">|</div>
        <a href="aboutUs"><div class="item">关于我们</div></a>
        <div class="border">|</div>
        <a href="news"> <div class="item">公司资讯</div></a>
        <div class="border">|</div>
        <el-popover placement="bottom" trigger="hover">
          <template #reference>
            <a href="businessnew"><div class="item">公司业务</div></a>
          </template>
          <a href="businessnew?type=1"><div class="one">培训服务</div></a>
          <a href="businessnew?type=2"><div class="one">资本服务</div></a>
          <a href="businessnew?type=3"><div class="one">产业服务</div></a>
          <a href="businessnew?type=4"><div class="one">咨询服务</div></a>
        </el-popover>
        <div class="border">|</div>
        <el-popover class="box-item" title="" content="暂未开放" placement="bottom">
          <template #reference>
            <a href=""><div class="item">数据库</div></a>
          </template>
        </el-popover>
        <div class="border">|</div>
        <a href="joinUs"><div class="item">联系我们</div></a>
      </div>
    </div>
    <!-- 主体 -->
    <div v-if="!isSeeMenuList">
      <main>
        <div class="top">
          <div class="title">
            <div class="imgBox"><img src="../../assets/wangxia.png" alt="" /></div>
            <div>
              <div class="chName">公司资讯</div>
              <div class="enName">/COMPANY NEWS</div>
            </div>
          </div>
          <!-- <div class="msg">企业成长的助力者，产业投资的连接者，资本市场服务新体系的践行者</div> -->
        </div>
        <!-- 新闻轮播 5个-->
        <div class="swiperBox">
          <el-carousel height="320px">
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/Hz3uVEDIZOYgBx_vHdOhmA" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/0525.webp" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    课程回顾 | AI × Web3，从智能融合到产业变革，WebX领军计划AI专题模块成功举办
                    </div>
                    <div class="msg">
                    5月22—23日，WebX领军计划AI专题模块课程在北京成功举办。本次课程以“AI × Web3：从智能融合到产业变革”为主题，汇聚顶尖学者、产业先锋与资本力量，围绕大模型、AI基础设施、算力芯片等前沿议题，通过主题授课、企业深度参访与闭门交流等多元形式，帮助学员沉浸式把握AI浪潮下的产业逻辑与实践机遇，助力实现从认知到应用的跨越。
                    </div>
                    <div class="time">2026-05-25</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/lZ6vtEmuy-4eX1mTi238Xw" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/0423.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    课程回顾 | 解码、进化、重塑：WEB3 领军人才计划二期班第二模块
                    </div>
                    <div class="msg">
                    行业年度盛会香港Web3嘉年华释放出明确信号，Web3 正迈向合规化、实体化、智能化新阶段，Web3正与AI、具身智能深度融合，构建智能经济底座，香港必将成为数字经济的关键枢纽。
                    </div>
                    <div class="time">2026-04-23</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/SinRwxbxdUN68dTkBCeXnw?scene=1&click_id=1" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/0324.webp" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    领航数字浪潮，WEB3领军人才计划二期班开学模块课程成功举办
                    </div>
                    <div class="msg">
                    2026年，Web3 行业正经历一场从概念爆发到价值落地的结构性转向。2026年3月20-22日，由中关村资本市场服务主办的“WEB3领军人才计划”二期班开学模块课程在香港成功举办。
                    </div>
                    <div class="time">2026-03-24</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/nwtRXEZ1OJfGbYxQMmfJKw" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/0127.webp" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    课程回顾 | WEB3领军人才计划首期班第二模块课程成功举办
                    </div>
                    <div class="msg">
                    2026年1月23-25日，由中关村资本市场服务主办的 “WEB3领军人才计划” 首期班第二模板课程在香港成功举办。
                    </div>
                    <div class="time">2026-01-27</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/v6eP0JhdGw_HCXp0WfaN6w" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/0113.webp" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    活动报道 | 场景赋能・科创共生 中关村论坛会员企业走进甬江科创区
                    </div>
                    <div class="msg">
                    1月8日至9日，以“场景赋能・科创共生”为主题的中关村论坛会员企业走进甬江科创区活动在浙江宁波成功举办。活动由中关村论坛会员单位——宁波市甬江科创区建设领导小组办公室、中关村论坛运营机构——北京中关村国际会展运营管理有限公司（以下简称“中关村国际会展公司”）联合举办。
                    </div>
                    <div class="time">2026-01-13</div>
                  </div>
                </div>
              </a>
            </el-carousel-item>
             <!-- <el-carousel-item>
              <a href="https://mp.weixin.qq.com/s/322vJEf2v432HYCN-ZZJjg" target="_blank">
                <div class="itemBox">
                  <div class="left"><img src="../../assets/huodong4.jpg" alt="" /></div>
                  <div class="right">
                    <div class="title">
                    中资服Family | “国产GPU第二股”沐曦股份科创板挂牌上市
                    </div>
                    <div class="msg">
                    12月17日，中关村资本市场服务数字领导力DBA学员企业——沐曦集成电路（上海）股份有限公司（股票简称：沐曦股份，股票代码：688802.SH）正式在上海证券交易所科创板挂牌上市。
                    </div>
                    <div class="time">2025-12-17</div>
                  </div>
                </div>
              </a>
            </el-carousel-item> -->
             
            
          </el-carousel>
        </div>
        <!-- 新闻列表 8条-->
        <div class="newsList">
           <a href="https://mp.weixin.qq.com/s/Hz3uVEDIZOYgBx_vHdOhmA" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">25</div>
                <div class="small">2026.05</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | AI × Web3，从智能融合到产业变革，WebX领军计划AI专题模块成功举办
                </div>
                <div class="message">
                 5月22—23日，WebX领军计划AI专题模块课程在北京成功举办。本次课程以“AI × Web3：从智能融合到产业变革”为主题，汇聚顶尖学者、产业先锋与资本力量，围绕大模型、AI基础设施、算力芯片等前沿议题，通过主题授课、企业深度参访与闭门交流等多元形式，帮助学员沉浸式把握AI浪潮下的产业逻辑与实践机遇，助力实现从认知到应用的跨越。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/lZ6vtEmuy-4eX1mTi238Xw" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">23</div>
                <div class="small">2026.04</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | 解码、进化、重塑：WEB3 领军人才计划二期班第二模块回顾
                </div>
                <div class="message">
                行业年度盛会香港Web3嘉年华释放出明确信号，Web3 正迈向合规化、实体化、智能化新阶段，Web3正与AI、具身智能深度融合，构建智能经济底座，香港必将成为数字经济的关键枢纽。
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/SinRwxbxdUN68dTkBCeXnw?scene=1&click_id=1" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">24</div>
                <div class="small">2026.03</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | 领航数字浪潮，WEB3领军人才计划二期班开学模块课程成功举办
                </div>
                <div class="message">
                2026年，Web3 行业正经历一场从概念爆发到价值落地的结构性转向。2026年3月20-22日，由中关村资本市场服务主办的“WEB3领军人才计划”二期班开学模块课程在香港成功举办。本次课程汇聚多位行业领袖与权威导师，课程体系进一步升级优化，助力学员精准把握Web3变革先机，完成一场深度交流学习的宝贵旅程。
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/nwtRXEZ1OJfGbYxQMmfJKw" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">27</div>
                <div class="small">2026.01</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | WEB3领军人才计划首期班第二模块课程成功举办
                </div>
                <div class="message">
                2026年1月23-25日，由中关村资本市场服务主办的 “WEB3领军人才计划” 首期班第二模板课程在香港成功举办。本次课程汇聚30余位行业大咖与专家学者，课程以 “理论 + 实践 + 应用” 为核心，为学员带来全方位、深层次的 Web3 领域知识盛宴，拆解Web3生态的底层逻辑与实战机遇。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/v6eP0JhdGw_HCXp0WfaN6w" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">13</div>
                <div class="small">2026.01</div>
              </div>
              <div class="right">
                <div class="tit">
                  活动报道 | 场景赋能・科创共生 中关村论坛会员企业走进甬江科创区
                </div>
                <div class="message">
                1月8日至9日，以“场景赋能・科创共生”为主题的中关村论坛会员企业走进甬江科创区活动在浙江宁波成功举办。活动由中关村论坛会员单位——宁波市甬江科创区建设领导小组办公室、中关村论坛运营机构——北京中关村国际会展运营管理有限公司（以下简称“中关村国际会展公司”）联合举办。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/322vJEf2v432HYCN-ZZJjg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">17</div>
                <div class="small">2025.12</div>
              </div>
              <div class="right">
                <div class="tit">
                  中资服Family | “国产GPU第二股”沐曦股份科创板挂牌上市

                </div>
                <div class="message">
                12月17日，中关村资本市场服务数字领导力DBA学员企业——沐曦集成电路（上海）股份有限公司（股票简称：沐曦股份，股票代码：688802.SH）正式在上海证券交易所科创板挂牌上市
                </div>
              </div>
            </div>
          </a>
          <a href="https://mp.weixin.qq.com/s/aII08jfTP2Mh-1kN5fpTMA" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">16</div>
                <div class="small">2025.12</div>
              </div>
              <div class="right">
                <div class="tit">
                  课程回顾 | 当WEB3遇见香港：WEB3领军人才计划首期班开课！

                </div>
                <div class="message">
                2025年12月12-14日，由中关村资本市场服务主办的 “WEB3领军人才计划” 首期班课程在香港正式开启。
                </div>
              </div>
            </div>
          </a>
           <a href="https://mp.weixin.qq.com/s/E0SWeBwmZBYPuaXprLmPNg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">12</div>
                <div class="small">2025.11</div>
              </div>
              <div class="right">
                <div class="tit">
                  DBA实践课堂 | 产学融合新范式：数字领导力企业家学者DBA北京实践课堂成功举办
                </div>
                <div class="message">
                 2025年11月6日，数字领导力企业家学者暨拉文大学DBA北京实践课堂成功举办。通过企业参访+深度研讨的形式，为同学们提供了沉浸式交流学习、思想碰撞的平台，共同探讨数字化时代背景下的企业创新发展新路径。
                </div>
              </div>
            </div>
          </a>
           <!-- <a href="https://mp.weixin.qq.com/s/NdaXV-Q449CudY9EyRKfFg" target="_blank">
            <div class="newsOne">
              <div class="left">
                <div class="big">29</div>
                <div class="small">2025.10</div>
              </div>
              <div class="right">
                <div class="tit">
                  活动报道 | 全球 RWA 前沿探索与商业实践，共探行业新机遇
                </div>
                <div class="message">
                  2025年10月26日，由学说科技、中关村资本市场服务主办——“全球 RWA 前沿探索与商业实践” 活动在学说空间成功举办，此次活动汇聚各行业精英、聚焦全球RWA，展开深度研讨。
                </div>
              </div>
            </div>
          </a> -->
           
        </div>
      </main>
      <div class="home-bottom">
        <div class="box">
          <div class="left">
            <div>联系我们</div>
            <!-- <div>工作时间：09:00—18:00</div> -->
            <!-- <div>服务热线： 高老师  13241800875</div> -->
            <div>邮箱：contact@zgccms.com</div>
            <div>地址：北京海淀区中关村大街11号e世界B区一层</div>
          </div>
          <div class="linkBox">
            <el-select v-model="value" @change="getNewLink(value)" placeholder="相关链接">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="right">
            <div class="addWx">
              <img src="../../assets/gzh.jpg" alt="" />
              <div class="wxtext">公众号二维码</div>
            </div>
            <!-- <div class="addWx"><img src="../../assets/getmore.png" alt=""></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const isSeeMenuList = ref(false);

const isSeeList = () => {
  isSeeMenuList.value = true;
};

const value = ref("");
const options = ref([
  {
    value: "https://www.tsinghua.edu.cn/",
    label: "清华大学",
  },
  {
    value: "https://www.pbcsf.tsinghua.edu.cn/",
    label: "清华大学五道口",
  },
  {
    value: "https://www.zgcgroup.com.cn/",
    label: "中关村发展",
  },
  {
    value: "https://www.51xueshuo.com/#/home",
    label: "学说平台",
  },
]);

const getNewLink = (current) => {
  window.open(current);
};
</script>

<style lang="less">
.newsContainer {
  .home-top {
    height: 500px;
    .head {
      padding: 58px 150px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
      .companyName {
        img {
          width: 250px;
        }
      }
      .phone {
        display: flex;
        width: 100px;
        font-size: 16px;
        color: #ffffff;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 15px;
        }
        .menuCopy {
          margin-left: 10px;
          display: none;
        }
      }
    }
    .menu {
      margin-top: -10px;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        .item {
          font-size: 18px;
          width: 236px;
          color: #ffffff;
        }
      }
      .border {
        color: #e1e1e1;
      }
    }
    .copyMenu {
      width: 100%;
      background-color: #fff;
      height: 100vh;
      margin-top: 196px;
      a {
        color: #333;
        letter-spacing: 2px;
        .item {
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #cecece;
        }
      }
    }
  }

  .home-top::before {
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(../../assets/newsbc.jpg) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 500px;
  }
  main {
    background: #e1e1e1;
    .top {
      padding-top: 50px;
      padding-bottom: 52px;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0070b7;
        .imgBox {
          width: 52px;
          height: 52px;
          margin-right: 14px;
          img {
            width: 52px;
            height: 52px;
          }
        }

        .chName {
          font-size: 30px;
          font-weight: 600;
        }
        .enName {
          font-size: 10px;
          margin-top: 2px;
          text-align: left;
          // font-weight: 600;
        }
      }
      // .msg{
      //     margin-top: 18px;
      //     color: #333333;
      //     font-size: 18px;
      //     font-weight: 600;
      // }
    }
    .swiperBox {
      width: 68%;
      margin: 0 auto;
      height: 340px;
      .itemBox {
        display: flex;
        justify-content: center;
        padding-left: 60px;
        padding-right: 60px;
        margin-bottom: 30px;
        position: relative;
        .left {
          width: 432px;
          height: 300px;
          margin-right: 36px;
          img {
            width: 432px;
            height: 300px;
          }
        }
        .right {
          max-width: 836px;
          text-align: left;
          .title {
            max-width: 556px;
            color: #333333;
            font-size: 16px;
            margin-bottom: 34px;
            white-space: nowrap;
          }
          .msg {
            color: #999999;
            font-size: 14px;
            margin-bottom: 70px;
          }
          .time {
            position: absolute;
            bottom: 27px;
            color: #999;
            font-size: 12px;
          }
        }
      }
    }
    .newsList {
      width: 68%;
      margin: 0 auto;
      .newsOne {
        display: flex;
        justify-content: center;
        padding-bottom: 50px;
        .left {
          text-align: center;
          width: 120px;
          padding-right: 32px;
          border-right: 2px solid #ccc;
          .big {
            font-size: 36px;
            line-height: 42px;
            color: #333;
            font-family: MicrosoftYaHei;
          }
          .small {
            font-size: 20px;
            color: #999;
            font-family: MicrosoftYaHei;
          }
        }
        .right {
          margin-left: 44px;
          text-align: left;
          .tit {
            font-size: 16px;
            color: #333;
            margin-bottom: 20px;
          }
          .message {
            font-size: 12px;
            color: #999;
            width: 896px;
            overflow: hidden;
          }
        }
      }
      .newsOne:hover .big {
        color: #0070b7;
      }
      .newsOne:hover .tit {
        color: #0070b7;
      }
    }
  }
  .home-bottom {
    height: 330px;
    color: #fff;
    .box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 70px;
      width: 68%;
      margin: 0 auto;
      .left {
        width: 300px;
        text-align: left;
        line-height: 40px;
        font-size: 18px;
        white-space: nowrap;
      }
      .right {
        display: flex;
        // visibility:hidden;
        .addWx {
          // margin-right: 175px;
          img {
            width: 100px;
            height: 100px;
          }
          .wxtext {
            // margin-top: 14px;
            font-size: 14px;
          }
        }
      }
      .linkBox {
        width: 230px;
      }
    }
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 330px rgba(0, 0, 0, 0.8);
    z-index: -1;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    //  top: 0;
    right: 0;
    left: 0;
  }

  .home-bottom::before {
    border-radius: 10px;
    content: ""; /* 伪元素需要内容，即使它是空的 */
    position: absolute;
    // top: 0;
    right: 0;
    left: 0;
    background: url(../../../public/images/homeBc.png) no-repeat center center,
      linear-gradient(180.06deg, rgb(46, 45, 45) 0.05%, rgb(30, 29, 29) 206.55%);
    background-size: cover;
    opacity: 1; /* 设置透明度 */
    z-index: -1; /* 确保伪元素在内容之下 */
    height: 330px;
  }
}

.el-carousel__indicators--horizontal {
  display: none;
}

/* 设备宽度小于768px时的样式 */
@media screen and (max-width: 768px) {
  body {
    min-width: 100%;
    font-size: 16px; /* 基准字体大小 */
  }
  .home-top {
    height: 246px !important;
    .head {
      padding: 10px 20px !important;
      padding-right: 10px !important;
      background: #032751 !important;
      .companyName {
        img {
          width: 130px !important;
        }
      }
    }
    .phone {
      width: auto !important;
      font-size: 0.8rem !important;
      img {
        width: 16px !important;
        height: 16px !important;
        margin-right: 6px !important;
      }
      .menuCopy {
        display: block !important;
      }
    }
    //   #header_font{
    //     width: 60%!important;
    //     height: 100px!important;
    //     top: 120px!important;
    //     p{
    //       width: 200px!important;
    //       height: 30px!important;
    //       font-size: 14px!important;
    //       margin: 0 auto!important;
    //     }
    //   }
    .menu {
      display: none !important;
    }
  }
  .home-top::before {
    height: 246px !important;
  }
  main {
    .top {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      // margin-bottom: 12px!important;
      .title {
        .imgBox {
          width: 30px !important;
          height: 30px !important;
          margin-right: 4px;
          img {
            width: 30px !important;
            height: 30px !important;
          }
        }
        .chName {
          font-size: 16px !important;
        }
        .enName {
          font-size: 10px !important;
          margin-top: 2px !important;
        }
      }
      .msg {
        font-size: 10px !important;
        margin-top: 6px !important;
      }
    }
    .swiperBox {
      width: 90% !important;
      height: 420px !important;
      .el-carousel__container {
        height: 420px !important;
      }
      .itemBox {
        display: block !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-bottom: 20px !important;
        .right {
          .title {
            white-space: normal !important;
            margin-bottom: 8px !important;
            margin-top: 8px !important;
            font-size: 15px !important;
          }
          .msg {
            margin-bottom: 20px !important;
          }
          .time {
            display: none;
          }
        }
        .left {
          width: auto !important;
          margin-right: 0px !important;
          height: 260px !important;
          img {
            width: 100% !important;
            height: 260px !important;
          }
        }
      }
    }
    .newsList {
      width: 90% !important;
      .newsOne {
        justify-content: left !important;
        padding-bottom: 14px !important;
        padding-top: 14px !important;
        border-bottom: 1px solid #ccc !important;
        .left {
          width: 70px !important;
          padding-right: 10px !important;
          .big {
            font-size: 22px !important;
          }
          .small {
            font-size: 16px !important;
          }
        }
        .right {
          width: calc(100% - 70px) !important;
          margin-left: 20px !important;
          overflow: hidden;
          .tit {
            margin-bottom: 10px !important;
            font-size: 15px !important;
          }
          .message {
            width: 100% !important;
            text-overflow: ellipsis !important;
            -webkit-line-clamp: 2 !important;
            overflow: hidden !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
  .home-bottom {
    position: relative;
    .box {
      width: 90% !important;
      .linkBox {
        display: none;
      }
    }
  }
  .home-bottom::after {
    box-shadow: 0 0 0px 66px rgba(0, 0, 0, 0.8) !important;
    width: 100vw !important;
    bottom: 66px;
  }
}
</style>
